<nav class="navbar navbar-default navbar-fixed-top">
  <div class="navdiv">
    <div class="navbar-header navhead">
      <a class="navbar-brand"><img src="https://res.cloudinary.com/finzy/image/upload/v1506445478/bitmap_rdyu22.png"></a>

      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#dropdownmenu"
              aria-expanded="false">
        <i class="material-icons navcolor">menu</i>
      </button>
    </div>

    <div class="collapse navbar-collapse" id="dropdownmenu">
    <ul class="nav navbar-nav" style="margin-left: 25%;">

      <li *ngIf="loanApplication" class="active"><a [routerLink]="dashLink"><p class="navoptions">LOAN APPLICATION</p></a>
      </li>

      <li *ngIf="borrowerDashboard" class="active"><a [routerLink]="dashLink"><p class="navoptions">MY DASHBOARD</p></a>
      </li>

      <li routerLinkActive="active" *ngIf="faqLink"><a [routerLink]="['/partnerfaq']" target="_blank" ><p class="navoptions">FAQ</p></a>
      </li>

      <li *ngIf="notLoggedIn" routerLinkActive="active"><a [routerLink]="['/login']"><p class="navoptions">LOGIN</p></a>
      </li>

      <li  *ngIf="loggedIn" class="onlyDesktop">
        <a  class="dropdown-toggle loggedHover name" data-toggle="dropdown">{{name}} <span class="caret"></span></a>
        <ul class="dropdown-menu">
         <li><a  class="subMenu" (click)="logout()"> &nbsp;&nbsp;<i class="fa fa-power-off fontaws" aria-hidden="true"></i>&nbsp; Logout &nbsp;&nbsp;</a></li>
        </ul>
      </li>

      <li *ngIf="loggedIn" class="onlyMobile"><a class="mobilePointer name"><p class="navoptions">{{name}}</p></a>
      </li>

      <li *ngIf="loggedIn" class="onlyMobile"><a class="mobilePointer" (click)="logout()"><p class="navoptions">LOGOUT</p></a>
      </li>

    </ul>

    <a class="navbar-brand navbar-right"><img src="https://res.cloudinary.com/finzy/image/upload/v1491394379/logoWeb1x_1_thzngg.png" alt="finzy logo"></a>

    </div>

  </div>
</nav>